import { ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/core/services/app.service';
import { ExcelService } from 'src/app/core/services/excel.service';
import { _CampagneService } from '../../../campagne/campagne-module.service';
import {  SelectService } from 'src/app/core/shared/select.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-logs-formation',
    templateUrl: './logs-formation.component.html',
    styleUrls: ['./logs-formation.component.css'],
})

export class LogsFormationComponent implements OnInit {
    @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();
    public listHistorique: any[];
    public agent_id: any;
    public response: any;
    public _type: any;
    public p = 1;
    public filter: string = '';
    public listCampagne: any[];
    public listType: any[];
    public anneeDataLoaded = false;
    public typeDataLoaded = false;
    public historiqueForm: FormGroup;


    bodyObject = {
        title: 'Liste des dernières demandes de formation',
        tableFields: [
            { header: 'ANNEE', width: 'auto', field: 'annee', align: 'left' },
            { header: 'TYPE FORMATION', width: 'auto', field: 'type_formation', align: 'left' },
            { header: 'INTITULE FORMATION', width: 'auto', field: 'intitule_formation', align: 'left' },
            { header: 'LIEU FORMATION', width: 'auto', field: 'lieu', align: 'left' },
            { header: 'DATE DEBUT', width: 'auto', field: 'date_debut', align: 'left', custom: true },
            { header: 'DATE FIN', width: 'auto', field: 'date_fin', align: 'left', custom: true },
        ],
    }

    constructor(
        private excelService: ExcelService,
        public activeModal: NgbActiveModal,
        private loadingBar: LoadingBarService,
        private _service: AppService,
        private toastrService: ToastrService,
        private fb: FormBuilder
    ) { }

    onDropdownClick(type: 'annee' | 'type') {
        if (!this.typeDataLoaded) {
            this._service.postData(`gestion-evaluations/formations/catalogue/getAllType`, {}).subscribe((res) => {
                this.listType = res.data;
                this.typeDataLoaded = true;
            });
        }
    }

    public clearValue() {
        this.historiqueForm.reset();
        this._type = '';
    }

    ngOnInit() {
      const url = window.location.href;
      const split_url = url.split('/');
      this.agent_id = split_url[7];
        this.initForm();
        this.pageCallback();

    }

    initForm(): void {
        this.historiqueForm = this.fb.group({
            annee: [null],
            date: [null],
            type: [null]
        });
    }

    public exportXls(): void {
        const exportData = this.listHistorique?.map(item => {
            const agent = {};
            this.bodyObject?.tableFields.forEach(field => {
                if (field.field !== 'actions' && field.field !== 'index') {
                    agent[field.header] = this.getNestedProperty(item, field.field);
                }
            });
            return agent;
        }) || [];
        this.excelService.exportAsExcelFile(exportData, this.bodyObject.title);
    }

    public getNestedProperty(obj: any, path: string): any {
        return path.split('.').reduce((o, key) => (o && o[key] !== undefined) ? o[key] : undefined, obj);
    }

    public getStatusClasses(statut: any): { [key: string]: boolean } {
        return {
            'badge-danger': statut === 'inactif',
            'badge-success': statut === 'actif',
        };
    }

    private transformData(data: any[]): any[] {
        return data.map((e, index) => ({
            id: e?.id,
            matricule: e?.matricule,
            agent_id: e?.agent_id,
            annee: e?.annee,
            lieu: e?.lieu,
            intitule_formation: e?.intitule_formation,
            type_formation: e?.type_formation,
            date_debut: `${e?.date_debut}`,
            date_fin: `${e?.date_fin}`,
            //   nomPrenoms: `${e?.qualite || ''} ${e?.nom || ''} ${e?.prenoms || ''}`.trim(),
        }));
    }

    onSubmit() {
        this.pageCallback();
    }

    public onPageChange(page: number) {
        this.pageChange.emit(page);
    }

    public pageCallback(): void {
        this.loadingBar.start();
        const formData = {
            agent_id: this.agent_id,
            ...this.historiqueForm.value,
            type: this._type?.type_stage
        };

        this._service.postData(`gestion-evaluations/formations/historiques/all?page=${this.p}`, formData).subscribe({
            next: (res: any) => {
                this.loadingBar.stop();
                this.response = res['data'];
                this.listHistorique = this.transformData(this.response.data);
            },
            error: (error) => {
                this.loadingBar.stop();
                this.toastrService.error(error.error.message);
            }
        });
    }

}
